export default __webpack_public_path__ + "static/mothers-day-aa57021ddb7aac2ed35c82a54a04f912.svg";